<section class="min-h-screen px-3 pb-8 pt-5 sm:px-5 lg:px-8">
  <div class="mx-auto max-w-[1600px]">

    <!-- Page header -->
    <div class="mb-5 flex items-center gap-3">
      <div class="flex h-10 w-10 items-center justify-center rounded-full bg-[#FFD4E0] text-[#D31148]">
        <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10" />
          <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
        </svg>
      </div>
      <div>
        <h1 class="text-xl font-bold text-gray-900">Blocked Users</h1>
        <p class="text-sm text-gray-500">People you've blocked — only you can see this list</p>
      </div>
    </div>

    <app-blocked-users></app-blocked-users>

  </div>
</section>

<app-scroll-to-top />
